import ControlState from '../controlState';
import JSONSchema7Properties from '../jSONSchema7Properties';
import PageState from '../pageState';

export default (pages: PageState[]): ControlState[] => {
  const fields: ControlState[] = [];
  const sortProperty = 'id';

  for (const page of pages) {
    for (const ctrl of page.controls) {
      const controlProperties = ctrl.schema
        ?.properties as JSONSchema7Properties;
      const isConditional = controlProperties['conditional']
        ?.default as boolean;

      if (isConditional) {
        fields.push(ctrl);
      }
    }
  }

  return fields.sort((ctrlA, CtrlB) => {
    const x = (ctrlA.schema?.properties as JSONSchema7Properties)[sortProperty]
      ?.default as string;
    const y = (CtrlB.schema?.properties as JSONSchema7Properties)[sortProperty]
      ?.default as string;
    return x < y ? -1 : x > y ? 1 : 0;
  });
};
